import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

import MapboxService from "./services/mapbox.service";

export default class MapboxProvider {
    #map = null
    constructor(options = {}) {
        this.mapParams = {
            container: 'mapbox',
            selector: '#mapbox',
            zoom: 16,
            minZoom: 5,
            maxZoom: 20,
            customAttribution: [
                '<a href="https://www.openmaptiles.org/" target="_blank">© OpenMapTiles</a>',
            ],
            style: `/wp-content/assets/map-styles/map-style.json`,
            pitch: 10,
            bearing: 0,
            transformRequest: MapboxService.transformRequest,
            ...options
        }
    }

    init(customParams = {}) {
        this.#map = new mapboxgl.Map(this.mapParams)

        const params = {
            navigation: true,
            navigationOptions: { showCompass: true, visualizePitch: true, showZoom: true },
            ...customParams
        }

        if (params.navigation)
            this.#map.addControl(new mapboxgl.NavigationControl(params.navigationOptions), this.mapParams.control)
    }

    getMap() {
        return this.#map;
    }

    createMarker({ id, markerTemplate, coords }) {
        if (id && markerTemplate) markerTemplate.dataset.id = id
        if (markerTemplate) markerTemplate.classList.add('js-marker')

        const marker = new mapboxgl.Marker(markerTemplate).setLngLat(coords)
        if (id) marker.markerID = id.toString()

		return marker
	}

    createPopup(args, template) {
		return new mapboxgl.Popup(args).setDOMContent(template)
	}


    addMarkerToMap(marker) {
		marker.addTo(this.#map)

		return marker
	}

    generateBounds(coords) {
        const bounds = new mapboxgl.LngLatBounds();
        coords.forEach( coordinates => {
            bounds.extend(coordinates);
        });
        return bounds;
    }

    fitBounds(bounds, {padding = 50} = {}) {
        this.#map.fitBounds(bounds, {padding});
    }

}
